import { EmployeeListComponent } from "@/Common/Components/AddEmployeePopup/EmployeeListComponent";
import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import ButtonGroup from "@/Common/Components/Buttons/ButtonGroup";
import { Modal } from "@/Common/Components/Modals/Modal";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { Person } from "@/Common/Models/Person/Person";

import styles from "./RemoveAllUsersWarningPopup.module.scss";

interface IRemoveAllUsersWarningPopupProps {
    employees: Person[];
    onClose?: () => void;
    onContinue?: () => void;
}

function RemoveAllUsersWarningPopup(props: Readonly<IRemoveAllUsersWarningPopupProps>): JSX.Element {
    const { getText } = useTranslation();

    const warningVocabKey = props.employees.length == 1 ? "RoleBasedAccessControl_RemoveUserWarning" : "RoleBasedAccessControl_RemoveAllUsersWarning";

    return (
        <div className={styles.RemoveAllUsersWarningPopup}>
            <Modal
                fixedOverlayPosition
                showOverlay
                centerContent
                draggable
                showX
                width={465}
                disableOverlayClose
                title={getText("WarningLabel").toTitleCase()}
                onClose={props.onClose}
                footer={(
                    <div className={`flex-display flex-end ${styles.buttonsContainer}`}>
                        <ButtonGroup>
                            <ButtonControl
                                onClick={props.onClose}
                                label={getText("CloseLabel")}
                                className="btn btn-default"
                            />
                        </ButtonGroup>
                        <ButtonControl
                            onClick={props.onContinue}
                            label={getText("ContinueLabel")}
                            className="btn btn-primary"
                        />
                    </div>
                )}
            >
                <div className="p-body">
                    <p>{getText(warningVocabKey)}</p>
                    <div className={styles.userListField}>
                        <EmployeeListComponent employees={props.employees} showDeleteIcons={false} onRemoveEmployeeClick={null} dataCy="RemoveAllUsersWarningPopup" />
                    </div>
                </div>
            </Modal>
        </div>
    );
}

export { RemoveAllUsersWarningPopup };
